import { redirect, type RouteObject } from 'react-router';
import { standaloneLayout } from '@/app/layouts';
import { ROUTES, buildPath } from '@/shared/routing';

/**
 * 약관 원문 화면 — `/agreements/:code` (이용약관·개인정보처리방침·환불정책).
 * public(비인증) — 앱 심사(스토어 콘솔 제출 URL)·딥링크 접근. subscription 과 달리
 * build-target gate 없음 — 앱에서도 약관을 볼 수 있어야 한다.
 * 원문 소스는 전 code 가 v3 consents — v2 를 남겨 둔 자리는 결제 경로뿐이다(`AgreementPage` 주석 참조).
 * bare `/agreements` 진입은 기본 약관(terms)으로 redirect.
 */
export function createAgreementRoute(): RouteObject {
  return {
    element: standaloneLayout({ width: 'sm' }), // TODO: 라우트별 width 값 지정 ('sm'|'md'|'lg'|'full')
    path: ROUTES.AGREEMENTS,
    children: [
      {
        index: true,
        loader: () => redirect(buildPath(ROUTES.AGREEMENT_DETAIL, { code: 'terms' })),
      },
      {
        path: ROUTES.AGREEMENT_DETAIL,
        lazy: { Component: () => import('@/pages/agreement').then((m) => m.AgreementPage) },
      },
    ],
  };
}
